export default {
  title: 'Artículos destacados',
  columns: {
    name: 'Nombre',
    quantity: 'Cantidad',
    amount: 'Importe',
  },
};
